import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './AccessibilityWidget.css';

const AccessibilityWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const toggleWidget = () => {
    setIsOpen(!isOpen);
  };

  const handleAccessibilityPage = () => {
    navigate('/accessibility');
    setIsOpen(false);
  };

  const increaseFontSize = () => {
    const currentSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
    if (currentSize < 20) {
      document.documentElement.style.fontSize = (currentSize + 2) + 'px';
    }
  };

  const decreaseFontSize = () => {
    const currentSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
    if (currentSize > 12) {
      document.documentElement.style.fontSize = (currentSize - 2) + 'px';
    }
  };

  const resetFontSize = () => {
    document.documentElement.style.fontSize = '16px';
  };

  const toggleHighContrast = () => {
    document.body.classList.toggle('high-contrast');
  };

  const toggleLargeText = () => {
    document.body.classList.toggle('large-text');
  };

  const toggleReadableFont = () => {
    document.body.classList.toggle('readable-font');
  };

  return (
    <>
      <div className="accessibility-widget">
        <button
          className="accessibility-toggle"
          onClick={toggleWidget}
          aria-label={isOpen ? 'סגור תפריט נגישות' : 'פתח תפריט נגישות'}
          aria-expanded={isOpen}
          title="תפריט נגישות"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM21 9V7L15 7.5V9M15 10.5V19L13.5 18.5V10.5M10.5 10.5V18.5L9 19V10.5M3 9V7L9 7.5V9M12 7.5C11.5 7.5 11 7.6 10.5 7.8V21C10.5 21.6 11.4 22 12 22S13.5 21.6 13.5 21V7.8C13 7.6 12.5 7.5 12 7.5Z"/>
          </svg>
        </button>

        {isOpen && (
          <div className="accessibility-menu" role="dialog" aria-labelledby="accessibility-menu-title">
            <div className="accessibility-menu-header">
              <h3 id="accessibility-menu-title">נגישות</h3>
              <button
                className="close-button"
                onClick={toggleWidget}
                aria-label="סגור תפריט נגישות"
              >
                ×
              </button>
            </div>

            <div className="accessibility-options">
              <div className="accessibility-section">
                <h4>גודל טקסט</h4>
                <div className="button-group">
                  <button onClick={increaseFontSize} aria-label="הגדל טקסט" title="הגדל טקסט">
                    A+
                  </button>
                  <button onClick={decreaseFontSize} aria-label="הקטן טקסט" title="הקטן טקסט">
                    A-
                  </button>
                  <button onClick={resetFontSize} aria-label="אפס גודל טקסט" title="אפס גודל טקסט">
                    A
                  </button>
                </div>
              </div>

              <div className="accessibility-section">
                <h4>תצוגה</h4>
                <button 
                  className="accessibility-option"
                  onClick={toggleHighContrast}
                  aria-label="הפעל/בטל ניגודיות גבוהה"
                >
                  <span className="icon">🎨</span>
                  ניגודיות גבוהה
                </button>
                
                <button 
                  className="accessibility-option"
                  onClick={toggleLargeText}
                  aria-label="הפעל/בטל טקסט גדול"
                >
                  <span className="icon">📖</span>
                  טקסט גדול
                </button>

                <button 
                  className="accessibility-option"
                  onClick={toggleReadableFont}
                  aria-label="הפעל/בטל גופן קריא"
                >
                  <span className="icon">🔤</span>
                  גופן קריא
                </button>
              </div>

              <div className="accessibility-section">
                <button 
                  className="accessibility-option primary"
                  onClick={handleAccessibilityPage}
                  aria-label="עבור להצהרת נגישות"
                >
                  <span className="icon">ℹ️</span>
                  הצהרת נגישות
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      {isOpen && (
        <div 
          className="accessibility-overlay" 
          onClick={toggleWidget}
          aria-hidden="true"
        />
      )}
    </>
  );
};

export default AccessibilityWidget;
